import React from 'react';
import {
  MenuItem,
  Grid,
  TextField,
} from '@mui/material';
import {
  ChipSelectList,
  DebouncedSearchInput,
  MultiCountrySelector,
} from '@marageti/z4-lib';
import PartnerSelector from '../../../components/partner-selector';
import { refineSoldChipOptions, sortByOptionsSoldTrips } from '../options';

type SoldTripsFiltersProps = {
  countries: string[],
  disableSortBy: boolean;
  onChange: (n: string, v: string | string[]) => void;
  partner: string;
  refineSold: string[];
  searchValue: string;
  sortBy: string;
};

const SoldTripsFilters = ({
  countries,
  disableSortBy,
  onChange,
  partner,
  refineSold,
  searchValue,
  sortBy,
}: SoldTripsFiltersProps) => (
  <Grid container spacing={{ mobile: 0, desktop: 2 }} mb={4}>
    <Grid item mobile={12} desktop={3}>
      <DebouncedSearchInput
        fullWidth
        key="fullText"
        label="Search"
        name="fullText"
        onChange={(v) => onChange('fullText', v)}
        defaultValue={searchValue}
      />
    </Grid>
    <Grid item mobile={12} desktop={3}>
      <MultiCountrySelector
        key="destination-select"
        label="Countries"
        name="countries"
        onChange={(e: React.SyntheticEvent, value: string[]) => onChange('countries', value)}
        value={countries}
      />
    </Grid>
    <Grid item mobile={12} desktop={3}>
      <PartnerSelector
        key="partner-select"
        label="Partner"
        name="partner"
        onChange={(_: React.SyntheticEvent, value: string) => onChange('partner', value)}
        value={partner}
      />
    </Grid>
    <Grid item mobile={12} desktop={3}>
      <TextField
        key="sort-by-select"
        label="Sort By"
        name="sort"
        onChange={(e) => onChange('sort', e.target.value)}
        select
        sx={{
          width: '100%',
          '& .MuiSelect-icon > svg > path': { color: 'primary.main' },
        }}
        value={sortBy}
        disabled={disableSortBy}
      >
        {sortByOptionsSoldTrips.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.title}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
    <Grid item mobile={12} desktop={12}>
      <ChipSelectList
        chipOptions={refineSoldChipOptions}
        label="Refine Sold"
        onChange={(v: string[]) => onChange('refineSold', v)}
        selectedChips={refineSold}
      />
    </Grid>
  </Grid>
);

export default SoldTripsFilters;
